'use strict';
import { trackAction } from 'helpers/trackingOM';
import 'components/subnav';

export default class CollectionsHubSubNav {
    constructor() {
        this.__initNavButtons();
        this.__setUpNavButtonsListeners();
    }

    __initNavButtons() {
        this.buttons = $('.subnav__items a');
    }

    __setUpNavButtonsListeners() {
        this.buttons.on('click', (e) => {
            const btn = $(e.target);

            this.category = btn.data('itemkey') ?? [];

            const element = $(e.currentTarget)[0];
            const columnPos = $(element).parent().prevAll('li').length.toString();
            const itemLabel = this.category
                ? `Collections-${this.category[0].toUpperCase() + this.category.slice(1)}`
                : 'Collections';

            trackAction('trackSubMenu', {
                menuItemLabel: itemLabel,
                posRowNum: '0',
                posColNum: columnPos,
                menuOrientation: 'header',
                pageName: collectionPageName,
                pageType: __hub.pageType ?? utag_data.pageType,
            });

            if (
                typeof collectionDefault !== 'undefined' &&
                collectionDefault &&
                typeof om != 'undefined'
            ) {
                om.trackState({
                    hubId: __hub.id ?? utag_data.hubId,
                    hubSlug: __hub.hubSlug ?? utag_data.hubSlug,
                    hubPageType: __hub.hubPageType ?? utag_data.hubPageType,
                    pageName: collectionPageName ?? utag_data.pageName,
                    pageType: __hub.pageType ?? utag_data.pageType,
                });
            }
        });
    }
}
